import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { AncientSea_Responsive } from "../AncientSea/game_responsive";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

// namespace SlotGames {

	export class AncientSeaLink_Responsive extends AncientSea_Responsive {
        
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData ) {
			super(multigameParams, initData, "AncientSeaLink");
    	}
	}

	